import COLORS from '../../colors';
import { LoadingIndicator } from '../LoadingIndicator';
import styled from 'styled-components';

const Logo = styled.img`
  width: 32px;
  height: 32px;
`;

const LogoContainer = styled.div`
  border-radius: 56px;
  background-color: ${COLORS.BLACK};
  border: 1px solid ${COLORS.NEUTRAL_700};
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FrameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

interface NetworkBreakdownLogoProps {
  image: string;
  loading: number;
}

const NetworkBreakdownLogo = ({
  image,
  loading
}: NetworkBreakdownLogoProps) => {
  return (
    <FrameContainer>
      <LogoContainer>
        <Logo src={image} />
      </LogoContainer>
      <LoadingIndicator loadingPercentage={loading} />
    </FrameContainer>
  );
};

export default NetworkBreakdownLogo;
